import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum AccountingSchedulesViewColumn {
    GROUP = "group",
    NAME = "name",
    DESCRIPTION = "description",
    JOURNAL_ENTRIES = "journalEntries",
    ENTITIES = "entities",
    STATUS = "status",
    ACTIONS = "actions",
}

const makeColumnSchema = (id: AccountingSchedulesViewColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const AccountingSchedulesViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.ACCOUNTING_SCHEDULES),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(AccountingSchedulesViewColumn.GROUP),
            makeColumnSchema(AccountingSchedulesViewColumn.NAME),
            makeColumnSchema(AccountingSchedulesViewColumn.DESCRIPTION),
            makeColumnSchema(AccountingSchedulesViewColumn.JOURNAL_ENTRIES),
            makeColumnSchema(AccountingSchedulesViewColumn.ENTITIES),
            makeColumnSchema(AccountingSchedulesViewColumn.STATUS),
            makeColumnSchema(AccountingSchedulesViewColumn.ACTIONS),
        ]),
    ),
});

export type AccountingSchedulesView = z.infer<
    typeof AccountingSchedulesViewSchema
>;
